import { render, staticRenderFns } from "./AddressBloc.vue?vue&type=template&id=755b19bc&"
import script from "./AddressBloc.vue?vue&type=script&lang=js&"
export * from "./AddressBloc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports